<template>
  <button
    :class="{
      'shoppinglist-button': true,
      'no-items': shoppinglistCount === 0
    }"
    v-on:click.prevent="openShoppinglist"
    tabindex="3"
    aria-controls="shoppinglistContainer"
    :aria-expanded="showShoppinglist"
    :aria-label="`Merkliste, ${shoppinglistCount > 0 ? shoppinglistCount + ' Produkte' : 'leer'}`"
  >
    <em id="shoppinglist-button-label">Merkliste</em>
    <span v-if="shoppinglist && shoppinglistCount > 0"
      >{{ shoppinglistCount }}
    </span>
  </button>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "shoppinglist-button",
  computed: {
    ...mapState(["shoppinglist", "showShoppinglist"]),
    ...mapGetters(["shoppinglistCount"])
  },
  methods: {
    openShoppinglist() {
      this.$trackPageView({ name: ":merkliste", hierarchy: [] });
      this.$store.commit("SET_SHOW_SHOPPINGLIST", true);
    }
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
.shoppinglist-button {
  position: fixed;
  right: 43px;
  top: 27px;
  z-index: 700;
  @include fontMedium;
  background: #ffffff url("/assets/images/shoppinglist-icon.png") no-repeat;
  background-size: 18px 17px;
  background-position: right 26px center;
  color: #000000;
  padding: 4px 50px 5px 18px;
  height: 40px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 100ms linear;
  &:hover {
    background-color: #ffffff;
  }
  &.no-items {
    padding-right: 38px;
    background-position: right 12px center;
  }
  @include mobile {
    background-color: transparent !important;
    background: transparent url("/assets/images/shoppinglist-icon-white.png") no-repeat;
    background-size: 18px 17px;
    padding: 0 50px 0 0;
    background-position: right 12px center;
    right: 5px;
    top: 3px;
    &.no-items {
      padding-right: 50px;
      background-position: right 12px center;
      right: 5px;
      top: 3px;
    }
  }
  em {
    font-style: normal;
    @include mobile {
      display: none;
    }
  }
  span {
    position: absolute;
    top: 4px;
    right: 12px;
    display: block;
    height: 18px;
    min-width: 18px;
    border-radius: 9px;
    font-size: px-to-rem(13);
    color: #ffffff;
    font-weight: bold;
    background: $color-red;
    line-height: px-to-rem(18);
    text-align: center;
    box-sizing: border-box;
    padding: 0 4px 0 2px;
    @include mobile {
      right: 0px;
    }
  }
}
#app.product .shoppinglist-button {
  color: #000000;
}
#app.shoppinglist .shoppinglist-button {
  display: none;
}
#app.preview .shoppinglist-button {
  display: none;
}
</style>
